import { h, render } from 'preact';
import StoreLocator from './store-locator';
import { LocationsContext } from './locations-context';

export default (element, data) => {
  const init = () => {
    render(
      <LocationsContext {...data}>
        <StoreLocator />
      </LocationsContext>,
      element,
    );
  };

  init();
};
